var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-main"},[_c('van-empty',{staticClass:"custom-image",attrs:{"image":_vm.custom,"description":"抱歉排队尚未开启"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }